import Link from 'next/link';
import { useMemo } from 'react';
import {
  AppStoreOutline,
  CheckCircleOutline,
  GooglePlayStore,
  type IconsNames,
} from '@eqi-investimentos/icons/web';
import { Button, Flex, SimpleGrid, Text } from '@eqi-investimentos/react';
import { GridItem } from '@chakra-ui/react';
import { appsStoreLinks } from '@/config/appsStoreLinks';
import { Icon } from '@/components/elements/Icon';
import { Thumb } from '@/components/elements/Thumb';
import { getLogoByTheme } from '@/utils/assets';
import { MobileFooter } from './Footer';

export const WebMobileDisclaimer = () => {
  const storeButtons = useMemo(
    () => (
      <SimpleGrid columns={2} gap="xs">
        <Button h="3.75rem" leftIcon={<GooglePlayStore />}>
          <Link href={appsStoreLinks.unique}>Google Play</Link>
        </Button>
        <Button h="3.75rem" leftIcon={<AppStoreOutline />}>
          <Link href={appsStoreLinks.unique}>App Store</Link>
        </Button>
      </SimpleGrid>
    ),
    []
  );

  return (
    <>
      <Flex direction="column" gap="2xl" px="m" py="4xl">
        <Thumb
          src={getLogoByTheme()}
          width={96}
          height={32}
          full
          fit="contain"
          alt="Logo EQI+"
        />
        <Text size="h6">Baixe agora o aplicativo EQI+ no seu smartphone</Text>
        <SimpleGrid columns={2} gridAutoFlow="column" gap="m">
          {cards.map(({ icon, text }) => (
            <Flex
              key={text}
              direction="column"
              gap="xs"
              bg="background.brandLight"
              p="m"
            >
              <Icon
                iconName={icon}
                width={20}
                height={20}
                color="content.brand"
              />
              <Text size="s" color="content.secondary">
                {text}
              </Text>
            </Flex>
          ))}
          <GridItem rowSpan={3} alignItems="center" ml="auto">
            <Thumb
              src="/assets/images/webmobile_disclaimer_image.png"
              width={168}
              height={350}
              full
              fit="contain"
              alt="logo-eqi"
            />
          </GridItem>
        </SimpleGrid>
        {storeButtons}
      </Flex>
      <Flex
        direction="column"
        gap="2xl"
        px="m"
        py="2xl"
        bg="background.brandLight"
      >
        <Text size="2xl" fontWeight="medium" color="content.primary">
          O aplicativo com mais vantagens para o investidor de alta renda
        </Text>
        {list.map((text) => (
          <Flex key={text} gap="xs">
            <CheckCircleOutline boxSize="1.5rem" color="content.brand" />
            <Text size="l" color="content.secondary">
              {text}
            </Text>
          </Flex>
        ))}
        {storeButtons}
      </Flex>
      <MobileFooter />
    </>
  );
};

const cards = [
  {
    icon: 'HomeOutline' as IconsNames,
    text: 'Mais controle para todo o seu patrimônio',
  },
  {
    icon: 'AccountBalanceOutline' as IconsNames,
    text: 'Mais qualidade nos serviços financeiros',
  },
  { icon: 'Book' as IconsNames, text: 'Mais informação para o seu dia a dia' },
];

const list = [
  'Consolidador de investimentos',
  'Otimizador de alocações',
  'Research com recomendações',
  'Previdência privada personalizada EQI',
  'Canais direto com seus assessores',
  'Noticias em tempo real',
  'Jornadas personalizadas por objetivo',
  'Cursos gratuitos',
  'Filmes e séries de investimentos',
  'Eventos online e presenciais',
];
